const GSAPLoader = {
    load: () => {
      return new Promise((resolve) => {
        if (window.gsap && window.ScrollTrigger) {
          gsap.registerPlugin(ScrollTrigger);
          return resolve();
        }
  
        const loadScript = (src) => new Promise(res => {
          const script = document.createElement('script');
          script.src = src;
          script.async = true;
          script.onload = res;
          document.head.appendChild(script);
        });
  
        Promise.all([
          loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.7/dist/gsap.min.js'),
          loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.7/dist/ScrollTrigger.min.js')
        ]).then(() => {
          gsap.registerPlugin(ScrollTrigger);
          resolve();
        });
      });
    },
  
    loadLenis: () => {
      return new Promise((resolve) => {
        if (window.Lenis) return resolve();
  
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/lenis@1.2.3/dist/lenis.min.js';
        script.async = true;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }
  };
